import { Dialog, DialogContent, DialogTitle, Divider } from '@material-ui/core';
import { useStyles } from './styles';
import { AgreementOne, AgreementTwo } from './Terms/Terms';

export type Terms =
  | 'serviceAgree'
  | 'privacyAgree'
  | 'promotionAgree'
  | 'paymentAgree';
interface props {
  openState: boolean;
  content: Terms;
  onClose: () => void;
}

const FullTextDialog = ({ openState, content, onClose }: props) => {
  const { root } = useStyles();

  return (
    <Dialog open={openState} onClose={onClose} className={root}>
      <DialogTitle>
        {content === 'serviceAgree'
          ? '서비스 이용약관'
          : content === 'privacyAgree'
          ? '개인정보처리방침'
          : content === 'promotionAgree'
          ? '마케팅정보수신동의'
          : '캐파결제 서비스 약관'}
      </DialogTitle>
      <Divider className="divider" />
      <DialogContent>
        {content === 'serviceAgree' ? (
          <AgreementOne />
        ) : content === 'privacyAgree' ? (
          <AgreementTwo />
        ) : content === 'promotionAgree' ? (
          <div className="agreement-content">
            <p className="content">
              {`
              ㈜에이팀벤처스는 개인정보보호법 및 정보통신망이용촉진및정보보호등에관한법률 등 관계법령에 따라 광고성정보를 전송하기 위해 수신자의 사전 수신동의를 받고 있으며, 광고성정보 수신자 의 수신동의여부를 정기적으로 확인합니다.

              - 전송방법
              고객님의 핸드폰 문자메시지(SMS), Email 등을 통해 전달될 수 있습니다.

              - 전송내용
              발송되는 마케팅 정보는 수신자에게 ㈜에이팀벤처스 및 캐파서비스 관련하여 제공하는 혜택 정보, 각종 이벤트 정보 등 광고성 정보로 관련 법의 규정을 준수하여 발송됩니다. 단, 광고성 정보 이외 의무적으로 안내되어야 하는 정보성 내용은 수신동의 여부와 무관하게 제공됩니다.

              - 철회안내
              고객님은 수신 동의 이후에라도 의사에 따라 동의를 철회할 수 있으며, 수신을 동의하지 않아도 회사가 제공하는 기본적인 서비스를 이용할 수 있으나, 당사의 마케팅 정보를 수신하지 못할 수 있습니다.

              - 수신동의 변경
              캐파서비스 홈페이지 우측 하단의 채널톡을 통해 수신동의를 변경(동의/철회)할 수 있습니다.

              - 개인정보 이용 상세내용
              휴대전화번호,이메일주소 - 혜택 정보,각종 이벤트 정보 등 광고성 정보 제공
          `}
            </p>
          </div>
        ) : (
          <div className="agreement-content">
            <p className="content">
              {`제 1조. (중개서비스의 성질과 목적)

중개서비스는 회사가 회원 각자의 자기결정에 의하여 고객과 파트너 상호 간에 서비스 및 물품 매매 거래가 이루어질 수 있도록 사이버 거래장소를 온라인으로 제공하는 것 이며, 캐파결제는 회원 상호 간에 서비스의 매매에 있어서 안전하고 편리하게 결제가 이루어질 수 있는 수단을 제공하는 것입니다. 회사는 회원에게 서비스 혹은 물품을 판매하거나 회원으로부터 서비스 혹은 물품을 구매하지 않으며, 단지 회원 간 거래의 안전성 및 신뢰성을 증진시키는 도구만을 제공합니다. 회원 간에 성립된 거래와 관련된 책임은 거래 당사자인 회원들 스스로가 부담하여야 합니다.


제 2조. (결제 서비스 이용)

① 회사는 결제방법에 대한 사항을 서비스화면을 통하여 공지합니다. 회원은 회사가 공지한 결제에 관한 정책사항을 사전에 충분히 이해하고 중개서비스를 이용하여야 합니다.

② 회원이 중개서비스를 통하여 구매하는 경우, 회사가 마련한 '캐파결제' 서비스를 통하여 거래를 완료할 수 있습니다. 회사는 거래 관계에서 발생하는 문제에 대하여 관여하거나 책임지지 않습니다.

③ 캐파 결제 서비스는 국내 신용카드 결제와 계좌이체(무통장 입금)을 지원 합니다. 결제수단은 추후 추가될 수 있습니다.


제 3조. (결제 서비스 소개 및 결제 서비스 정책)

① 회사는 중개서비스를 제공하는 과정에서 대금의 수령, 보관 및 정산 업무로 이루어지는 에스크로 방식의 '캐파결제' 서비스를 제공합니다. 캐파결제 서비스 수수료는 ‘결제망 이용료’와 ‘결제 관리 수수료’를 모두 포함합니다.

1. 에스크로 : 이해관계 없는 제3자가 대금을 보관하며, 고객의 구매확인 의사(구매결정)를 통보 받은 이후에 보관된 결제 대금을 지급하는 안전한 결제서비스 방식
2. 결제망 이용료 : 캐파결제 서비스 이용 비용과 결제대금예치업자 (주)나이스페이먼츠에게 지불하는 비용을 모두 포함
3. 결제 관리 수수료 : 회사가 캐파 결제 시스템을 운영하는데 필요한 비용
4. 대금 : 고객이 지불한 결제 금액을 의미
5. 보관 : 고객 결제 후, 파트너에게 정산하여 송금하기 전까지 회사의 가상계좌에 해당 거래대금을 예치하는 행위
6. 정산 : 고객이 구매확정 후 혹은 자동구매확정 이후 집금된 거래대금을 파트너에게 정산하는 행위

② 이러한 캐파결제는 중개서비스를 통하여 이루어지는 회원 상호 간의 거래의 안전성과 신뢰성을 도모하고 회원을 보호하기 위한 목적에서 제공하는 장치이므로 회사가 캐파결제를 통하여 회원을 대리, 대행하거나 그 이행을 보조하는 것은 아닙니다.

③ 회원은 회사가 제공하는 캐파결제를 이용함에 있어서, 이용방법과 그 규칙에 동의하여야 합니다.

④ 캐파결제의 일환으로 이루어지는 대금 보관으로 인하여 회사가 취득하는 이자 등은 서비스 제공의 대가이므로 회원은 회사에 대하여 이자 등의 반환을 청구할 수 없고, 결제로 인하여 발생하는 일체의 수수료는 고지된 수수료율에 따라 파트너가 부담하여야 합니다.

⑤ 회사가 제공하는 캐파결제를 이용하지 않은 거래 (외부 결제) 또는 구매확정되어 캐파결제가 종결된 거래의 경우, 해당 거래와 관련하여 발생한 모든 사항은 고객과 파트너간 상호 합의를 통해 해결하여야 합니다.

⑥ 회사가 제공하는 캐파결제를 오용·악용함으로써 사회질서, 미풍양속을 침해하거나 침해할 우려가 있다고 판단되는 경우와 회사가 캐파결제를 제공하지 못할 상황 또는 사유가 발생하는 경우, 회사는 거래를 제한할 수 있습니다. 또한, 판·구매 행위가 허위 또는 불법 결제에 해당하는 경우, 그 밖의 정당한 사유가 있는 경우 회사는 주문취소, 활동중지, 이용제한 등의 필요한 조치를 취할 수 있으며, 진행 중인 거래를 보류하거나 취소할 수 있습니다. ⑦ 캐파결제를 이용함에 있어 고객은 다음에 기재한 사유가 발생하지 않도록 유의하여야 합니다. 1) 카드의 미서명, 관리 소홀, 대여, 양도, 보관, 이용 위임, 담보제공, 불법대출 등으로 인한 부정사유 또는 위, 변조 사고 2) 회원의 가족, 동거인(사실상의 동거인 포함)에 의하거나 또는 이들이 관련하여 생긴 부정사용 또는 위, 변조 사고 3) 카드 비밀번호 유출로 인한 부정사용 또는 위, 변조 사고 4)

⑧ 캐파결제 서비스는 금융위원회에 등록된 전자금융업 허가 및 등록을 한 결제대금예치업자 (주)나이스페이먼츠를 통해 파트너를 대행하여 고객(지급인)이 파트너(수취인)에게 지급하여야 할 자금의 내역을 전자적인 방법으로 지급인에게 고지, 수수, 정산합니다.

⑨ 캐파결제로 결제한 모든 거래는 (주)나이스페이먼츠의 결제대금예치 서비스가 적용됩니다. 따라서 해당 서비스에 대해서는 (주)나이스페이먼츠의 서비스이용약관이 적용됩니다.

⑩ 캐파결제를 이용한 거래에 동의하고, 정산 정보 (정산 계좌 및 휴대폰 본인 인증 정보)를 등록한 파트너에 한하여 캐파결제 서비스를 이용할 수 있습니다.

⑪ 각 거래에 대한 캐파결제 서비스는 고객의 요구에 따라 개시됩니다. 파트너는 거래 금액과 서비스 이행 완료일을 포함한 서비스 내용을 고객에게 전자적 형태로 전달한 후 고객이 결제를 진행합니다. 회사는 파트너에게 캐파결제 수수료를 사전에 고지합니다.

⑫ 파트너가 서비스를 이행한 이후 고객이 거래 확정을 하면 회사는 결제대금예치업자를 통해 수수료를 제외한 서비스 금액을 파트너에게 지급합니다.

⑬ 분쟁 및 그 밖의 사유 발생시 회사는 합리적인 판단에 따라 고객과 파트너에게 이용 제한 등의 필요한 조치를 취할 수 있으며, 진행 중인 거래의 서비스 대금 지급이나 서비스 대금 환불을 보류할 수 있습니다.


제 4조. (구매 과정)

① 고객이 캐파결제를 선택하여 결제하면, 회사는 입금 정보와 환불 정보를 지정된 양식에 따라 구매관리, 예치금 내역 화면에 표시합니다. 캐파결제를 이용하지 않는 외부 결제 등 회사의 고의 또는 중대한 과실이 없는 거래 대금 결제에 대한 위험과 책임은 고객이 부담하여야 하고, 회사는 이에 대하여 아무런 책임을 지지 않습니다.

② 고객은 신용카드로 대금을 결제할 수 있습니다. 단, 현재 해외 카드를 이용한 결제는 불가능합니다.

③ 고객은 가상계좌이체(무통장 입금)를 통해 대금을 결제할 수 있습니다.

④ 캐파결제 서비스를 통하여 결제한 고객은 대금의 결제, 예치, 지급 등의 상태를 캐파를 통해서 확인할 수 있습니다.


제 5조. (세금계산서 발행)

회사는 중개 업체로 세금계산서 발행 주체가 될 수 없으며 실제 서비스를 제공한 파트너가 세금계산서 발행 주체가 됩니다. 캐파결제 이용시 고객이 파트너에게 세금계산서 요청을 할 수 있습니다.


제 6조. (구매확정 및 파트너 정산)

① 고객은 의뢰한 서비스 또는 제품을 수령한 후 수정/취소 요청을 하지 않고 구매를 최종 결정하게 되면, 파트너에 대한 대금 정산을 위하여 즉시 구매확정을 해야 합니다. 구매확정을 하게 되면 고객이 회사에 보관 의뢰한 결제 대금은 파트너에게 이관 처리되므로 구매확정 이후에 발생하는 환불, A/S 등은 고객과 파트너가 직접 연락하여 해결하여야 합니다.

② 고객이 구매확정을 한 경우, 회사는 결제 대금에서 결제 서비스 수수료를 공제한 나머지 금액을 파트너 수익금으로 예치합니다. 일반 정산 정책에 따라, 구매확정일로 부터 영업일 기준 5일 이내에 파트너에게 예치됩니다.

③ 파트너는 회원 가입 후 회사로부터 수익금을 수령할 계좌를 지정하여야 하며, 회사가 정하는 바에 따라 계좌를 변경할 수 있습니다. 이때, 파트너가 지정한 입금계좌의 예금주는 파트너로 가입시 제출한 사업자등록증 상의 상호명과 일치해야함을 원칙으로 합니다. 가입 정보와 상이한 경우 정산이 불가능하며 해당 조건에 맞는 계좌 관련 서류 증빙이 완료될 때까지 판매 대금의 송금을 보류할 수 있습니다.

④ 고객이 발송 완료일로부터 7일 이내에 수정, 취소, 반품, 교환 등의 의사를 표시하지 않고 구매 확정을 지연하는 경우, 파트너가 배송지 입력을 한 날로부터 영업일 기준 16일째 되는 날 자동 구매확정 처리가 되고 결제 대금 중 캐파 결제 서비스 수수료를 공제한 수익금은 영업일 기준 최대 20일째 되는 날 파트너에게 예치됩니다. 다만, 위 기간 이내에 검수완료 후 고객이 수정,교환 또는 환불요청 등의 의사표시를 한 후에도 해당 서비스 또는 물품을 지속적으로 사용한 경우 파트너에게 수익금 예치를 진행할 수 있습니다. 회사의 수익금 정산 이후 고객의 A/S 또는 환불의 의사표시가 있는 경우 파트너와 고객의 책임으로 모든 문제를 해결하여야 하며, 회사는 이에 개입하거나 책임지지 않습니다.


제 7조. (구매 취소 및 환불)

① 취소 요청

결제 후, 파트너가 작업 시작 전까지 고객은 결제 취소요청이 가능합니다. 이를 확인하지 못하여 발생된 피해에 대해 회사는 책임을 지지 않습니다. 그 외의 취소·환불 조건은 당사자간의 합의에 의해 변경될 수 있으며, 이 경우 회사는 이에 개입하거나 책임지지 않습니다.

② 환불 요청

결제 이후, 의뢰한 프로젝트 작업이 시작되면, 고객은 취소가 아닌 환불 요청이 가능합니다. 고객에게 전액 환불 시, 고객에게 환불되는 금액에서 결제망 이용료 금액 (VAT포함) 만큼 차감 후 환불됩니다. 고객에게 일부 환불, 파트너에게 일부 정산되어야 하는 경우, 원칙상 파트너에게 캐파결제 수수료가 적용된 금액으로 정산되며 고객에게는 합의된 환불 대금 그대로 지급됩니다.

고객의 구매확정 또는 자동구매확정으로 캐파결제 대금이 회사에 귀속되어, 파트너에게 정산이 완료된 경우에도 관련 법령에 따라 고객은 수정·교환 및 취소·환불을 요청할 수 있습니다. 단, 이 경우 취소는 환불 요청으로 간주되며 고객과 파트너가 직접 연락하여 해결하여야 합니다. 회사는 이에 개입하거나 책임지지 않으며, 정산된 결제 수수료를 반환하지 않습니다.

③ 이 약관에 규정된 캐파결제가 종료된 후 회사의 중개서비스를 통해 거래된 서비스의 수정·교환 및 취소·환불 등과 관련하여 파트너와 고객, 운송 업체, 금융기관 등과 사이에 분쟁 등이 발생한 경우 관련 당사자 간에 해결하여야 하고, 회사는 이에 대하여 관여하지 않으며 어떠한 책임도 부담하지 않습니다. 또한, 해당 분쟁 사안의 결제대행업체 또는 금융기관의 약관이 우선됩니다.

④ 파트너의 귀책사유로 다수의 취소 및 환불요청이 발생하는 경우 또는 동일 서비스 카테고리 내 타 서비스보다 거래 취소 비율이 현저히 높은 경우 회사는 파트너의 활동 제한 등의 조치를 취할 수 있습니다.


제 8조. (캐파결제에 대한 회사의 면책)

① 캐파결제는 고객과 파트너 회원 간 거래의 안전성과 편의성 향상을 목적으로 회사가 제공하는 서비스의 일환이므로 회사는 회사의 고의 또는 중대한 과실이 없는 한 캐파결제 서비스를 이용하는 양 당사자 간의 거래에 어떠한 책임도 지지 않습니다.

② 회사는 캐파결제 서비스를 이용하는 파트너와 고객 회원 중 어느 일방을 대리, 대행하거나 그 이행을 보조하는 위치에 있지 아니합니다. 회사는 거래 당사자 간 자금의 흐름에 직접 관여하거나 개입하지 않으며, 회사와 계약을 체결한 결제대금예치업자가 고객 회원이 입금한 금액을 파트너에게 전달합니다.

③ 파트너가 캐파결제 이용 시 잘못된 정보를 입력하여 잘못된 대금지급이 이루어졌을 경우 회사는 이에 대하여 책임지지 않습니다. 또한, 고객이 결제를 이용한 해당 결제 건에 대하여 환불요청시 잘못된 정보를 입력하여 잘못된 대금 지급이 이루어졌을 경우 회사는 이에 대하여 책임지지 않습니다.

④ 캐파결제 대금이 파트너에게 정산되기 전, 고객이 취소/환불 요청하였으나 파트너가 거부하는 경우, 회사는 고객 요청 승인하지 않고 일단 처리 보류합니다. 일정 시간이 지나 해당 거래 금액이 회사의 가상계좌에 입금된 후에는 파트너와 고객 합의될 때까지 지급을 보류하며, 이후 합의된 사항에 따라 이행합니다.

⑤ 고객이 거래를 확정하면 캐파결제가 종료됩니다. 따라서 거래 확정 후 대금의 지급이 완료된 이후 발생한 분쟁 또는 불만 사항은 거래 당사자가 협의를 통해 해결해야 합니다. 거래 확정 후 파트너의 정산 정보 미등록으로 인한 거래 승인 대기 중에도 거래 확정은 철회되지 않습니다.
`}
            </p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default FullTextDialog;
